'use client'

import { useAtomValue } from 'jotai'
import { useMemo } from 'react'

import { activePageIdAtom, dashboardLayoutsAtom } from '@/state/dashboard-layouts'

/** The widget kind (ComponentKey) of a placed widget, found by its instance id. */
export function useWidgetComponentKey(cardId: string): string | undefined {
  const layouts = useAtomValue(dashboardLayoutsAtom)
  const activePageId = useAtomValue(activePageIdAtom)

  return useMemo(() => {
    const active = activePageId ? layouts[`/trade/${activePageId}`] : undefined
    const find = (components: { id: string; componentKey: string }[] | undefined) =>
      components?.find((c) => c.id === cardId)?.componentKey
    // The active page first; any page otherwise (a popped-out or shared view).
    return (
      find(active?.activeComponents) ??
      Object.values(layouts).reduce<string | undefined>(
        (hit, layout) => hit ?? find(layout?.activeComponents),
        undefined
      )
    )
  }, [layouts, activePageId, cardId])
}
